export default __webpack_public_path__ + "static/media/term-condition-bm.ddd6f246.svg";